
export const getOrderStatusColor = (status) => {
    switch (status) {
        case 'PROCESS':
        case 'INITIATE':
            return 'bg-info/10 text-info';
        case 'ACCEPTED':
            return 'bg-success/10 text-success';
        case 'PLACED':
            return 'bg-warning/10 text-warning';
        case 'PREPARING':
            return 'bg-primary/10 text-primary';
        case 'TRANSIT':
            return 'bg-secondary/10 text-secondary';
        case 'DELIVERED':
        case 'COMPLETED':
        case 'REFUND_COMPLETED':
        case 'REFUND COMPLETED':
            return 'bg-success/10 text-success';
        case 'CANCELLED':
        case 'REFUND_FAILED':
        case 'REFUND FAILED':
        case 'FAILED':
        case 'DECLINED':
            return 'bg-danger/10 text-danger';
        case 'PENDING':
            return 'bg-warning/10 text-warning';
        case 'PAID':
            return 'bg-success/10 text-success';
        case 'REFUND_INITIATED':
        default:
            return 'bg-gray-100 text-gray-800';
    }
}


export const ORDER_STATUS_TAKE_AWAY_OPTIONS = [
    { value: 'ACCEPTED', label: 'ACCEPTED' },
    { value: 'PREPARING', label: 'PREPARING' },
    { value: 'READY', label: 'READY' },
    { value: 'COMPLETED', label: 'COMPLETED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
]

export const ORDER_STATUS_DELIVERY_OPTIONS = [
    { value: 'ACCEPTED', label: 'ACCEPTED' },
    { value: 'PREPARING', label: 'PREPARING' },
    { value: 'TRANSIT', label: 'TRANSIT' },
    { value: 'DELIVERED', label: 'DELIVERED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
]


export const ORDER_STATUS_LIST = {
    PROCESS: "INITIATE",
    ACCEPTED: "ACCEPTED",
    PLACED: "PLACED",
    PREPARING: "PREPARING",
    TRANSIT: "TRANSIT",
    READY: "READY",
    COMPLETED: "COMPLETED",
    DELIVERED: "DELIVERED",
    CANCELLED: "CANCELLED",
    FAILED: "FAILED",
    PENDING: "PENDING",
    PAID: "PAID",
    COD: "COD",
    REFUND_INITIATED: "REFUND INITIATED",
    REFUND_COMPLETED: "REFUND COMPLETED",
    REFUND_FAILED: "REFUND FAILED",
    DECLINED: "DECLINED",
}
export const REFUND_STATUS_LIST = {
    REFUND_INITIATED: "REFUND_INITIATED",
    REFUND_COMPLETED: "REFUND_COMPLETED",
    REFUND_FAILED: "REFUND_FAILED",
}
export const ALL_ORDERS_STATUS_LIST = [
    ORDER_STATUS_LIST.PROCESS,
    ORDER_STATUS_LIST.ACCEPTED,
    ORDER_STATUS_LIST.PLACED,
    ORDER_STATUS_LIST.PREPARING,
    ORDER_STATUS_LIST.TRANSIT,
    ORDER_STATUS_LIST.READY,
    ORDER_STATUS_LIST.COMPLETED,
    ORDER_STATUS_LIST.DELIVERED,
    ORDER_STATUS_LIST.PENDING,
    ORDER_STATUS_LIST.CANCELLED,
    ORDER_STATUS_LIST.PAID,
    ORDER_STATUS_LIST.COD,
    REFUND_STATUS_LIST.REFUND_INITIATED,
    REFUND_STATUS_LIST.REFUND_COMPLETED,
    REFUND_STATUS_LIST.REFUND_FAILED
]
export const DISPUTE_ORDERS_STATUS_LIST = [
    ORDER_STATUS_LIST.FAILED,
    ORDER_STATUS_LIST.CANCELLED,
    ORDER_STATUS_LIST.DECLINED
]
export const ORDER_PAYMENT_STATUS = [
    { value: 'REFUND_INITIATED', label: 'REFUND INITIATED' },
    { value: 'REFUND_COMPLETED', label: 'REFUND COMPLETED' },
    { value: 'REFUND_FAILED', label: 'REFUND FAILED' },
]

export const ORDER_PAYMENT_STATUS_COD = [{ value: 'PAID', label: 'PAID' },]

export const SERVICES = {
    DELIVERY: "DELIVERY",
    TAKEAWAY: "TAKEAWAY",
    GLOBAL_DELIVERY: "GLOBAL_DELIVERY",
    GLOBAL_TAKEAWAY: "GLOBAL_TAKEAWAY",
    DINE_IN: "DINE_IN"
}

export const PAYMENT_MODES = {
    COD: "COD",
    ONLINE: "ONLINE",
    VALUE_PLUS: "VALUE_PLUS",
    VALUE_PLUS_ONLINE: "VALUE_PLUS_ONLINE"
}
export const PROCESS = "PROCESS"
